import { getSecondsInTimeInterval } from 'client/modules/Date';
import { TimeInterval } from 'client/modules/Date/types';
import { getApiUrl } from 'client/modules/Url';

export type FetchStationPublishedEpisodesByDateRangeProps = {
  webStationId: string;
  timeInterval: TimeInterval;
  range?: {
    timeRangeStart: number; // epoch time
    timeRangeEnd: number;
  };
};

export type FetchStationPublishedEpisodesByDateRangeResponse = {
  data: {
    columnHeaders: [
      { name: string; type: string },
      { name: string; type: string }
    ];
    rows: [string, number][]; // [episodeTitle, publishDate]
  };
  kind: 'publishedEpisodes';
  parameters: {
    timeInterval: number;
    timeRange: [number, number];
  };
  stationId: number;
};

export async function fetchStationPublishedEpisodesByDateRange({
  webStationId,
  timeInterval = 'hour',
  range,
}: FetchStationPublishedEpisodesByDateRangeProps): Promise<FetchStationPublishedEpisodesByDateRangeResponse> {
  try {
    const url = getApiUrl({
      path: `analytics/station/webStationId:${webStationId}/publishedEpisodes`,
      queryParameters: {
        timeInterval: getSecondsInTimeInterval(timeInterval),
        ...(range && {
          timeRangeStart: range.timeRangeStart,
          timeRangeEnd: range.timeRangeEnd,
        }),
      },
    });
    const resp = await fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
    });

    if (resp.ok) {
      return resp.json();
    }

    throw new Error('Could not fetch station published episodes by date range');
  } catch (err) {
    throw new Error(err.message);
  }
}
